import classNames from 'classnames';

import Stats from '../partials/Stats';

import styles from '../../../styles/blocks/stats.module.css';

interface StatsBlockProps extends StatsBlock {
    className?: string;
    isContainer?: boolean;
    containerClassName?: string;
}

function StatsBlock({ title, stats, className, isContainer, containerClassName }: StatsBlockProps) {
    return (
        <div className={classNames([styles.container, className])}>
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <div className={styles.box}>
                    {title != null ? <h4 className={styles.title}>{title}</h4> : null}
                    <Stats className={styles.stats} stats={stats} />
                </div>
            </div>
        </div>
    );
}

export default StatsBlock;
